export default __webpack_public_path__ + "static/media/AMNH_11.92d8a495.png";